export default {
  title: 'Restablecer contraseña',
  instructions: 'Se enviará un mensaje al correo electrónico para restablecer la contraseña.',
  recoverPasswordButton: 'Continuar',
  returnLogindButton: 'Regresar',
  tryAgainButton: 'Reintentar',
  success: {
    label: 'El mensaje ha sido enviado exitosamente.'
  },
  email: {
    inputLabel: 'Correo electrónico'
  }
}
